import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import NavigationBar from '../../../navigation/NavigationBar';
import { getUrlParams } from '../../../../utils/shared/urlUtils';
import { getGradeYearString, getGradeNavTabs } from './gradeNavTabs';

const GradeYearHeader = ({
    gradeYears,
    location,
    selectedGradeYear,
    selectGradeYear,
    LinkWrapper,
}) => {
    useEffect(() => {
        selectGradeYear(getUrlParams(location).gradeYear);
    }, []);

    return (
        <NavigationBar
            divTagClassName="grade-nav"
            ulTagClassName="nav nav-horizontal"
            tabs={getGradeNavTabs(gradeYears, getUrlParams(location))}
            selectedTabId={getGradeYearString(selectedGradeYear)}
            onNavigationTabClick={selectGradeYear}
            LinkWrapper={LinkWrapper}
        />
    );
};

GradeYearHeader.defaultProps = {
    selectedGradeYear: {},
    gradeYears: [],
    LinkWrapper: () => {},
};

GradeYearHeader.propTypes = {
    location: PropTypes.object.isRequired,
    gradeYears: PropTypes.arrayOf(PropTypes.object),
    selectedGradeYear: PropTypes.object,
    selectGradeYear: PropTypes.func.isRequired,
    LinkWrapper: PropTypes.func,
};

export default GradeYearHeader;
